import React from "react";
import { useMerchantTheme } from "@/hooks/useMerchantTheme";
import { useTransactionData } from "@/context/transactionContext";
import TransactionDetails from "./TransactionDetails";
import TransactionDetails1xbet from "./TransactionDetails1xbet";
import TransactionDetailsStake from "./TransactionDetailsStake";
import TransactionDetailsPix from "./TransactionDetailsPix";

function TransactionDetailsIndex() {
  const { is1xbet, isStake } = useMerchantTheme();
  const { transactionData } = useTransactionData();
  const isPix = transactionData?.bank_payment_method === "pix";

  if (is1xbet) return <TransactionDetails1xbet />;
  if (isStake) return <TransactionDetailsStake />;
  if (isPix) return <TransactionDetailsPix />;

  return <TransactionDetails />;
}

export default TransactionDetailsIndex;
